import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, FormHelperText, FormControl, Grid, InputAdornment, InputLabel, Link, MenuItem, Select, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { CreditCard, VpnKey, DateRange, Label } from '@material-ui/icons';
import { actionPostPaymentTransaction, actionShopCartShowTransFee, actionShopCartSetMmbAmountToPay } from 'actions';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import CryptoAES from 'crypto-js/aes'
import CryptoENC from 'crypto-js/enc-utf8';
import { actionSetFormErrorState } from 'actions';
import ErrorHandling from '../ErrorHandling/ErrorHandling';
import { red } from '@material-ui/core/colors';
import './Globalpayments.css';
import DialogeBox from '../DialogeBox/DialogeBox';
import ReactHtmlParser from 'react-html-parser';
import MultiPayments from '../../views/Checkout/components/MultiPayments';
import { genfunction } from 'helpers'

const { BillingAddressTypeID, GPCardNumberErrorMsg, GPCVVErrorMsg, GPExpiryErrorMsg, GlobalPaymentsApiKey,
    GlobalPaymentsEnvironment, GlobalPaymentsBaseURL, GlobalPaymentsEnableAutocomplete, TermsnConditionCheckMsg,
    StreetAddressTypeID, RecaptchaV3Client, TermsnConditionCheckBoxText, UseStreetAddressForAVS, EnableAlternateMerchantOnline, ApplyTransactionFee } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    heading: {
        marginTop: "-18px",
        color: "#000000",
        "font-size": "11px",
        "font-family": "Roboto, Helvetica, Arial, sans-serif",
        "font-weight": "400",
        "letter-spacing": "-0.05px",
        "transform": "translate(0, 1.5px) scale(0.75)",
        "transform-origin": "top left"
    },
    iconforiframe: {
        "z-index": "1 !important",
        "margin-top": "20px"
    },
    box100per: {
        "margin-top": "-72px"
    },
    mmbfakedisableButton: {
        "margin-top": "-72px"
    },
    errorTxt: {
        color: "#e53935"
    },
    errorInput: {
        border: red
    },
    hidden: {
        visibility: "hidden"
    },
    visible: {
        visibility: "visible"
    },
    FullWidth: {
        width: "100%"
    },
    PayBtnDisable: {
        'pointer-events': 'none !important'
    },
    PayBtnUnDisable: {
        'pointer-events': 'auto !important'
    }

}));


const { forwardRef, useRef, useImperativeHandle } = React;

const GlobalPayments = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({

        refPayByCardOnFile() {
            PayByCardOnFile();
        },
        refReload() {
            Reload();
        }

    }));


    let val = 0;
    const classes = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const errorstate = useSelector(state => state.reducerFormError.errorstate);
    const formfields = useSelector(state => state.reducerFormError.formfields);
    const events = useSelector(state => state.reducerShopCart.events);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const gatickets = useSelector(state => state.reducerShopCart.GATickets);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const customer = useSelector(state => state.reducerCustomer);
    const reducerBooking = useSelector(state => state.reducerBooking);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);
    const showTransFee = useSelector(state => state.reducerShopCart.showTransactionFee);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);
    const donation = useSelector(state => state.reducerShopCart.donation);
    let shopcartamounttoPay = useSelector(state => state.reducerShopCart.mmbAmountToPay);
    const refundType = useSelector(state => state.reducerShopCart.refundType);
    let enteredAmountToPay = useSelector(state => state.reducerShopCart.enteredAmountToPay);
    const PaymentInfoError = useSelector(state => state.reducerPaymentTransaction.PaymentInfoError);
    const stopUserToPurchase = useSelector(state => state.reducerGlobal.stopUserToPurchase);


    const [showPayBtn, setShowPayBtn] = useState(false);
    const [tncchecked, settncChecked] = React.useState(false);
    const [opentnc, setopentnc] = useState(false);
    const [errorMsg, seterrorMsg] = useState("");
    const [cardDetails, setCardDetails] = useState({});

    let cardNumberRef = useRef();
    let cvvRef = useRef();
    let expiryDateRef = useRef();
    let submitRef = useRef();

    const tnccheckeHandle = (event) => {
        settncChecked(event.target.checked);
    };

    useEffect(() => {
        // if (val == 0) {
        const script = document.createElement("script");
        script.src = GlobalPaymentsBaseURL;
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => scriptLoaded();
        //  val++;
        // }
    }, []);


    useEffect(() => {

        if ((events.length > 0 || membershipPackages.length > 0 || gatickets.length > 0 || orderProducts.length > 0 || ShowGiftCards() || donationProducts.length > 0) || props.AdditionBooking && tncchecked) {
            setShowPayBtn(true);
        }
        else {
            setShowPayBtn(false);
        }
    }, [events, tncchecked, formfields])

    useEffect(() => {

        if (errorMsg && errorMsg.length > 0 || PaymentInfoError && PaymentInfoError.length > 0) {
            if (window && window.toggleButtonState) {
                window.toggleButtonState(true);
            }
        }

    }, [errorMsg, PaymentInfoError]);


    const Reload = () => {

        if (cardNumberRef.current && cvvRef.current && expiryDateRef.current && submitRef.current) {
            cardNumberRef.current.innerHTML = "";
            cvvRef.current.innerHTML = "";
            expiryDateRef.current.innerHTML = "";
            submitRef.current.innerHTML = "";
        }

        window.GlobalPayments.configure({
            "X-GP-Api-Key": CryptoAES.decrypt(GlobalPaymentsApiKey, '1271').toString(CryptoENC),
            "X-GP-Environment": GlobalPaymentsEnvironment,
            enableAutocomplete: GlobalPaymentsEnableAutocomplete,
        });

        var cardForm = window.GlobalPayments.ui.form({
            fields: {
                "card-number": {
                    target: "#card-number",
                    placeholder: "???????????? ???????????? ???????????? ????????????",
                },
                "card-expiration": {
                    target: "#card-expiration",
                    placeholder: "MM / YYYY",
                },
                "card-cvv": {
                    target: "#card-cvv",
                    placeholder: "?????????",
                },
                submit: {
                    target: "#submit",
                    text: "Pay",
                },
            },
            styles: {
                //adding a radius on all text inputs

                "#secure-payment-field.card-number": {
                    "font-family": "Roboto, Helvetica, Arial, sans-serif",
                    "padding": "4px 5px 4px 30px",
                    "font-size": "16px",
                    "border": "none !important",
                    "border-bottom": "1px solid gray !important",
                    "width": "100% !important"
                },

                ".card-number.card-type-amex": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-amex@2x.png) no-repeat right",
                    "background-position-y": "-12px",
                    "background-size": "55px 98px"
                },
                ".card-number.card-type-discover": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-discover@2x.png) no-repeat right",
                    "background-position-y": "-11px",
                    "background-size": "90px 96px"
                },
                ".card-number.card-type-jcb": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-jcb@2x.png) no-repeat right",
                    "background-position-y": "-6px",
                    "background-size": "48px 82px"
                },
                ".card-number.card-type-mastercard": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-mastercard@2x.png) no-repeat right",
                    "background-position-y": "-3px",
                    "background-size": "60px 64px"
                },
                ".card-number.card-type-visa": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-visa@2x.png) no-repeat right",
                    "background-position-y": "-6px",
                    "background-size": "70px 75px"
                },

                "#secure-payment-field.card-cvv": {
                    "font-family": "Roboto, Helvetica, Arial, sans-serif",
                    "padding": "4px 5px 4px 30px",
                    "font-size": "16px",
                    "border": "none !important",
                    "border-bottom": "1px solid gray !important",
                    "width": "25% !important"
                },

                "#secure-payment-field.card-expiration": {
                    "font-family": "Roboto, Helvetica, Arial, sans-serif",
                    "padding": "4px 5px 4px 30px",
                    "font-size": "16px",
                    "border": "none !important",
                    "border-bottom": "1px solid gray !important",
                    "width": "25% !important"
                },

                "input[type=text]:focus-visible, input[type=tel]:focus-visible": {
                    "outline": "none !important",
                    "border": "none !important",
                    "border-bottom": "1px solid gray !important",
                },

                "#secure-payment-field.submit:hover": {
                    "text-decoration": "none",
                    "background-color": "rgba(0, 0, 0, 0.04)",
                    "color": "#000000"
                },
                "input.invalid": {
                    "-webkit-box-shadow": "inset 0px 0px 4px 0px #ff0a0a",
                    "box-shadow": "inset 0px 0px 4px 0px #ff0a0a",
                    "border-color": "#ff8282"
                },

                "button[type=button]": {
                    "background-color": theme.palette.primary.main,
                    "color": theme.palette.primary.contrastText,
                    "flex-basis": "100%",
                    "font-size": "14px",
                    "margin": "0 auto",
                    "height": "38px",
                    "box-sizing": "border-box",
                    "border": "none",
                    "border-radius": "4px",
                    "cursor": "pointer",
                    "position": "relative",
                    "align-items": "center",
                    "font-weight": "500 !important",
                    "line-height": "1.75",
                    "text-transform": "uppercase",
                    "letter-spacing": "0.02857em",
                    "font-family": "Roboto Helvetica Arial sans-serif !important"
                },
                "button:active": {
                    "filter": "brightness(112%)"
                }
            }
        });

        return cardForm;
    }
    const scriptLoaded = () => {

        var cardForm = Reload();
        var isCallInititaed = false;

        window.GlobalPayments.on("error", (resp) => {
            if (props.showFreeTicket === false) {
                seterrorMsg("Global Payment is not configured correctly, please contact administrator for more details.");
            }
        });

        cardForm.on("token-success", (resp) => {
            if (!isCallInititaed) {
                window.toggleButtonState(false);
                setCardDetails(resp);
            }

        });

        function timeout(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
        async function updatetsates() {
            ResetCreditCard();
            await timeout(3000);
        }

        cardForm.on("token-error", function (resp) {

            window.toggleButtonState(true);
            updatetsates();

            if (resp && resp.error) {

                if (resp.error.detail && resp.error.detail.length > 0 && resp.error.detail[0].hasOwnProperty('data_path')) {

                    if (resp.error.detail[0].data_path.includes('card_number') || resp.error.detail[0].data_path.includes('card-number')) {
                        errorfield('number', GPCardNumberErrorMsg, true);
                    }

                    if (resp.error.detail[0].data_path.includes('security')) {
                        errorfield('cvv', GPCVVErrorMsg, true);
                    }

                    if (resp.error.detail[0].data_path.includes('expiry_year') || resp.error.detail[0].data_path.includes('card-expiration')) {
                        errorfield('MonthAndYear', GPExpiryErrorMsg, true);
                    }

                    if (resp.error.detail[0].description.includes('expiry')) {
                        errorfield('MonthAndYear', GPExpiryErrorMsg, true);
                    }
                }

                if (resp.error.code && resp.error.code.includes('invalid_card')) {
                    errorfield('number', GPCardNumberErrorMsg, true);
                }
            }
        });

        cardForm.on("card-number-test", (resp) => {
            if (resp.valid)
                errorfield('number', '', false);
        });

        cardForm.on("card-expiration-test", (resp) => {
            if (resp.valid)
                errorfield('MonthAndYear', '', false);
        });


        cardForm.on("card-cvv-test", (resp) => {
            if (resp.valid)
                errorfield('cvv', '', false);
        });

        // called during callbacks, changes CSS of Submit button if all 3 callbacks return true
        // by calling addStylesheet on cardForm (PayFields) object
        window.toggleButtonState = (isEnabled) => {

            cardForm.addStylesheet(isEnabled ? {
                "button": {
                    "color": "#FFFFFF",
                    "background-color": "#0000FF",
                    "pointer-events": "auto",
                    "cursor": "pointer"
                }
            } : {
                "button": {
                    "background": "#e0f1ff",
                    "color": " #808080",
                    "pointer-events": "none",
                    "cursor": "not-allowed"
                }
            });

            if (!isEnabled) {
                isCallInititaed = true;
            } else {
                isCallInititaed = false;
            }
        };
    };

    const PayByCardOnFile = () => {

        var booking = reducerBooking.booking[0];

        let cardonfileToken = "";
        let cardMaskedNum = "";
        let cardType = "";

        if (booking && booking.hasOwnProperty('PaymentToken') && booking.PaymentToken.length > 10) {
            cardonfileToken = booking.PaymentToken.substring(booking.PaymentToken.length - 10);
        }

        if (booking && booking.hasOwnProperty('PaymentDescription') && booking.PaymentDescription.length > 10) {
            cardType = booking.PaymentDescription.substring(0, booking.PaymentDescription.indexOf('-') - 1).trim();
            cardMaskedNum = booking.PaymentDescription.substring(booking.PaymentDescription.indexOf('-') + 1, booking.PaymentDescription.length).trim();
        }

        if (RecaptchaV3Client && RecaptchaV3Client != '') {
            executeRecaptcha("checkout").then(recaptchaToken => {
                paymentTokenHandler({ token: cardonfileToken, cardtype: cardType, cardnumber: cardMaskedNum }, customer.customer && customer.customer.length > 0 ? customer.customer : "", recaptchaToken);
            }).catch(error => {
                seterrorMsg("Recaptcha token not fetched")
            })
        }
        else {
            paymentTokenHandler({ token: cardonfileToken, cardtype: cardType, cardnumber: cardMaskedNum }, customer.customer && customer.customer.length > 0 ? customer.customer : "", "");
        }
    }


    const PurchaseItems = (resp) => {

        if (genfunction.IsObjectNotNullOrEmptyOrUndefined(resp)) {
            if (resp.hasOwnProperty('cvv_present') && resp.cvv_present === false) {
                errorfield('cvv', 'Card CVV is required.', true);
                window.toggleButtonState(true);
                return;
            }
        }

        if (!props.ValidatePaymentFields()) {
            window.toggleButtonState(true);
            return;
        }

        if (props.ValidatePaymentFields()) {

            ResetCreditCard();

            if (props.mmbPayBy === undefined || props.mmbPayBy !== "CardOnFile") {

                var client = GetClient(formfields.first_name.value, formfields.last_name.value, formfields.email.value.trim(), UseStreetAddressForAVS ? formfields.address1.value : '',
                    formfields.address2.value, formfields.city.value, formfields.state.value, formfields.zip.value, formfields.country.value, formfields.phone_number.value,
                    formfields.shipping_address1.value, formfields.shipping_address2.value, formfields.shipping_city.value, formfields.shipping_state.value,
                    formfields.shipping_zip.value, formfields.shipping_country.value, formfields.shipping_phone_number.value);

                if (!props.showFreeTicket) {
                    if (RecaptchaV3Client && RecaptchaV3Client != '') {
                        executeRecaptcha("checkout").then(recaptchaToken => {
                            paymentTokenHandler({ token: resp.temporary_token, cardtype: resp.card.type, cardnumber: resp.card.masked_card_number }, client, recaptchaToken);
                        }).catch(error => {
                            seterrorMsg("Recaptcha token not fetched")
                        })
                    }
                    else {
                        paymentTokenHandler({ token: resp.temporary_token, cardtype: resp.card.type, cardnumber: resp.card.masked_card_number }, client, "");
                    }
                }

                if (props.showFreeTicket) {
                    if (RecaptchaV3Client && RecaptchaV3Client != '') {
                        executeRecaptcha("checkout").then(recaptchaToken => {
                            paymentTokenHandler({ token: null }, client, recaptchaToken);
                        }).catch(error => {
                            seterrorMsg("Recaptcha token not fetched")
                        })
                    }
                    else {
                        paymentTokenHandler({ token: null }, client, "");
                    }
                }
            }
        }
        else if (props.managemyBooking && props.mmbPayBy === "CardOnFile") {
            PayByCardOnFile();
        }
    }


    useEffect(() => {

        if (cardDetails && cardDetails.hasOwnProperty('temporary_token') && cardDetails.temporary_token.length > 0) {
            PurchaseItems(cardDetails);
        }
    }, [cardDetails])

    const ResetCreditCard = () => {

        errorfield('number', '', false);
        errorfield('cvv', '', false);
        errorfield('MonthAndYear', '', false);
    }

    const ShowGiftCards = () => {
        let res = false;
        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.filter(x => x.AddedToCart === true).length > 0) {
                res = true;
            }
        }
        return res;
    }

    const errorfield = (errorfield, errortext, errorstate) => {
        actionSetFormErrorState(dispatch, errorfield, errortext, errorstate);
    }

    const paymentTokenHandler = (token, client, recaptchaToken) => {
        actionPostPaymentTransaction(dispatch, token, client, recaptchaToken);
    }

    const GetClient = (firstName, lastName, email, street1, stree2, city, state, postCode, country, mobilePhone, shipping_address1, shipping_address2, shipping_city, shipping_state,
        shipping_zip, shipping_country, shipping_phone_number) => {

        var client = [
            {
                "CustomerType": "Individual",
                "FirstName": firstName,
                "LastName": lastName,
                "CreatedAsGuest": true,
                "GuestEmail": email,
                "DateOfBirth": null,
                "CustomerAddress": [
                    {
                        "IsPrimaryAddress": true,
                        "AddressTypeID": StreetAddressTypeID,
                        "Email": email,
                        "Street1": street1,
                        "Street2": stree2,
                        "CitySuburb": city,
                        "State": state,
                        "Postcode": postCode,
                        "Country": country,
                        "MobilePhone": mobilePhone
                    },
                    {
                        "IsPrimaryAddress": false,
                        "AddressTypeID": BillingAddressTypeID,
                        "Email": email,
                        "Street1": shipping_address1,
                        "Street2": shipping_address2,
                        "CitySuburb": shipping_city,
                        "State": shipping_state,
                        "Postcode": shipping_zip,
                        "Country": shipping_country,
                        "MobilePhone": shipping_phone_number
                    }
                ],
                "LinkedIndividuals": []
            }
        ]

        return client;
    }

    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const getTNC = () => {
        return ReactHtmlParser(TermsnConditionCheckMsg);
    }

    const GetTransOptionalText = () => {
        let optionalTxt = '';
        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            optionalTxt = transactionfee.transactionFee[0].TransactionFeeOptionalText;

            if (refundType === "AdditionalPayment" || (refundType === "" && shopcartamounttoPay > 0))
                optionalTxt += ' [' + genfunction.ccyFormat(parseFloat(genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], enteredAmountToPay, cashlesstotal))) + ']';

            else
                optionalTxt += ' [' + genfunction.ccyFormat(parseFloat(genfunction.TransactionFee(events, donation, transactionfee.transactionFee[0], cashless, membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts))) + ']';
        }

        return optionalTxt;
    }

    useEffect(() => {

        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            if (transactionfee.transactionFee[0].TransactionFeeByDefault) {
                actionShopCartShowTransFee(dispatch, true);
            }
        }

    }, [transactionfee])

    const transFeeCheckHandler = (event) => {
        actionShopCartShowTransFee(dispatch, event.target.checked);

        let transFee;
        if (props.managemyBooking) {

            if (refundType === "AdditionalPayment" || (refundType === "" && shopcartamounttoPay > 0)) {
                transFee = genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], enteredAmountToPay, cashlesstotal)
            }
            else {
                transFee = genfunction.TransactionFee(events, donation, transactionfee.transactionFee[0], cashless, membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts);
            }

            let amoutToPay = event.target.checked ? genfunction.Rounded(shopcartamounttoPay + transFee) : genfunction.Rounded(shopcartamounttoPay - transFee);
            actionShopCartSetMmbAmountToPay(dispatch, amoutToPay);
        }

    };

    const transFeeCheckBox = () => {

        let showTFBox = true;

        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            if (transactionfee.transactionFee[0].TransactionFeeOptional === false && transactionfee.transactionFee[0].TransactionFeeByDefault === false) {
                showTFBox = false;
                if (!showTransFee && ApplyTransactionFee) {
                    actionShopCartShowTransFee(dispatch, true);
                }
            }
        }

        return showTFBox;
    };

    return (
        <div>
            <ErrorHandling msg={errorMsg} open={errorMsg && errorMsg.length > 0} handleclose={errorcancelhandle} />
            {props.showFreeTicket === false ?
                <>
                    <form id="form1" method="get" >
                        <FormControl role="form">
                            <Grid container item spacing={2} >
                                <Grid item xs={12} sm={6} >
                                    <div>
                                        <label className={classes.heading}>Card Number</label>

                                        <InputAdornment position="start">
                                            <CreditCard className={classes.iconforiframe} color="primary" />
                                        </InputAdornment>
                                        <div id="card-number" ref={cardNumberRef}>

                                        </div>
                                        <FormHelperText className={classes.errorTxt}>{errorstate.number.errorstate ? errorstate.number.errortext : ''}</FormHelperText>
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <div>
                                        <label className={classes.heading} shrink="true">CVV</label>

                                        <InputAdornment position="start">
                                            <VpnKey color="primary" className={classes.iconforiframe} />
                                        </InputAdornment>
                                        <div id="card-cvv" ref={cvvRef}>

                                        </div>
                                        <FormHelperText className={classes.errorTxt}>{errorstate.cvv.errortext}</FormHelperText>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} >
                                    <div>
                                        <label className={classes.heading}>Card Expiry</label>

                                        <InputAdornment position="start">
                                            <DateRange color="primary" className={classes.iconforiframe} />
                                        </InputAdornment>

                                        <div className={classes.errorInput} id="card-expiration" ref={expiryDateRef}>
                                        </div>
                                        <FormHelperText className={classes.errorTxt}>{errorstate.MonthAndYear.errortext}</FormHelperText>
                                    </div>
                                </Grid>

                                {ApplyTransactionFee && transFeeCheckBox() === true ?
                                    < Grid item xs={12} sm={12}>
                                        <Checkbox
                                            color="primary"
                                            checked={showTransFee}
                                            onChange={transFeeCheckHandler}
                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                        />
                                        <Typography color="textSecondary" component="span" >
                                            {GetTransOptionalText()}
                                        </Typography>
                                    </Grid>
                                    : null}

                                <Grid item xs={12} sm={12}>
                                    <Checkbox
                                        color="primary"
                                        checked={tncchecked}
                                        onChange={tnccheckeHandle}
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                    <Typography color="textSecondary" component="span" >
                                        {TermsnConditionCheckBoxText}
                                        <Link href="#" onClick={() => { setopentnc(true) }} > Terms and Conditions </Link>
                                    </Typography>

                                </Grid>
                                <Grid item xs={12}>
                                    {tncchecked && EnableAlternateMerchantOnline ? <MultiPayments /> : null}
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <>
                                        <div id="submit" className={(showPayBtn ? classes.visible : classes.hidden) + " " +
                                            (!tncchecked || stopUserToPurchase === true ? classes.PayBtnDisable : classes.PayBtnUnDisable)} ref={submitRef}>
                                        </div>
                                        <Button
                                            disabled={!props.AdditionBooking}
                                            className={classes.primarycolor + " " + classes.FullWidth + " " +
                                                (props.mmbPayBy === false ? classes.box100per : classes.mmbfakedisableButton) + " " +
                                                (showPayBtn ? classes.hidden : classes.visible)}
                                        >Pay</Button>
                                    </>

                                </Grid>
                            </Grid>
                        </FormControl >
                    </form>
                </>
                :
                <>
                    <Grid item xs={12} sm={12}>
                        <Checkbox
                            color="primary"
                            checked={tncchecked}
                            onChange={tnccheckeHandle}
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                        <Typography color="textSecondary" component="span" >
                            {TermsnConditionCheckBoxText}
                            <Link href="#" onClick={() => { setopentnc(true) }} > Terms and Conditions </Link>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Button
                            disabled={!tncchecked}
                            className={classes.primarycolor + " " + classes.FullWidth} onClick={() => PurchaseItems(null)}>Pay</Button>
                    </Grid>
                </>
            }

            <DialogeBox open={opentnc} title={"Terms and Conditions"}
                message={getTNC()}
                button1text={"Close"}
                button1clickhandler={() => { setopentnc(false) }}></DialogeBox>

        </div >
    );
});

export default GlobalPayments;
